import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    IdBankAccount: { label: i18n.t('app.id'), value: '' },
    PaymentType: { label: i18n.t('tipos.metadata.pago'), value: '' },
    AccountType: { label: i18n.t('agenda.account_type'), value: '' },
    IBANAccountNumber: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
    BankCode: { label: i18n.t('agenda.bank_code'), value: '' },
    BranchCode: { label: i18n.t('agenda.branch_code'), value: '' },
    Address: { label: i18n.t('address.location'), value: '' },
    PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
    Town: { label: i18n.t('address.poblacion'), value: '' },
    Province: { label: i18n.t('address.provincia'), value: '' },
    CountryCode: { label: i18n.t('address.pais'), value: '' },
    BIC: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
    DomiciliationDate: { label: i18n.t('agenda.domiciliation_date'), value: '', type: 'date' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
    { field: 'IdBankAccount', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'PaymentType', width: '200px', title: i18n.t('tipos.metadata.pago'), format: 'FORMAS_DE_PAGO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'AccountType', width: '170px', title: i18n.t('agenda.account_type'), format: 'TIPOS_CUENTA', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'IBANAccountNumber', width: '250px', title: i18n.t('invoices.invoices_issuing.iban'), columnMenu: 'myTemplate', locked: false },
    { field: 'BankCode', width: '180px', title: i18n.t('agenda.bank_code'), columnMenu: 'myTemplate', locked: false },
    { field: 'BranchCode', width: '160px', title: i18n.t('agenda.branch_code'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.Address', width: '200px', title: i18n.t('address.location'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.PostCode', width: '160px', title: i18n.t('address.codigo_postal'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.Town', width: '130px', title: i18n.t('address.poblacion'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.Province', width: '120px', title: i18n.t('address.provincia'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.CountryCode', width: '100px', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'BIC', width: '140px', title: i18n.t('invoices.invoices_issuing.bic_swift'), columnMenu: 'myTemplate', locked: false },
    { field: 'DomiciliationDate', width: '220px', title: i18n.t('agenda.domiciliation_date'), cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false },
    { 
      field: 'idSociedad', 
      title: 'Id Sociedad', 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      },
    },
    { 
      field: 'idSede', 
      title: 'Id Sede', 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      },
    },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
